import React from 'react';
import ReactDOM from 'react-dom';
import _debug from 'debug';
import DiffusionList from './components/DiffusionList';
import configureStore from 'common/redux/configureStore';
import { Provider } from 'react-redux';
import $ from 'jquery';
import { error } from 'plugins/toastr';
import { hideLoader } from 'plugins/loader';
import fetch from 'utils/fetch';

const debug = _debug('app::news-diffusion');

export function index() {
  debug('Rendering news diffusion list');
  // const token = window.__ADMIN_TOKEN__
  // if (token) {
  const root = document.getElementById('diffusion-list');
  const store = configureStore();
  ReactDOM.render(
    <Provider store={store}>
      <DiffusionList id={root.getAttribute('data-id')} />
    </Provider>,
    root
  );

  $('form').on('submit', evt => {
    evt.preventDefault();

    const $form = $(evt.currentTarget);
    const data = new FormData($form[0]);

    const targets = store.getState().news.targets.toArray();
    data.append('targets', JSON.stringify(targets));

    // Submitting
    const url = $form.attr('action');
    fetch(url, {
      method: 'POST',
      body: data,
    }).then(
      res => {
        if (res.url) {
          window.location.replace(res.url);
        } else {
          window.location.reload(true);
        }
        console.log(res);
      },
      err => {
        console.log('Error attempting to save news', err);

        hideLoader();

        if (err.res.status === 400) {
          // Handling errors properly
          err.res.json().then(json => handleFormErrors(store, $form, json));
        } else {
          error("Une erreur est survenue pendant la sauvegarde de l'actualité");
        }
      }
    );

    return false;
  });
}

function handleFormErrors(store, $form, errors) {
  // Clearing existing errors
  $form.find('.field').removeClass('error');

  const formError = errors[0];
  if (formError && formError.key) {
    $form
      .find(`input[name="${formError.key}"]`)
      .closest('.field')
      .addClass('error');
  }
}



// WEBPACK FOOTER //
// ./src/modules/news/index.js